export const searchLevel1Sectors = /* GraphQL */ `
  query SearchLevel2Sectors {
    searchSectors(
      filter: {level: {eq: 1} , provider : { eq : "factset" } },
      sort: {field: name, direction: asc}
    ) {
      items {
        id
        level
        name
      }
      nextToken
      total
    }
  }
`

export const searchSharesBySector = /* GraphQL */ `
  query SearchShares(
    $filter: SearchableShareFilterInput
    $sort: SearchableShareSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchShares(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        name
        close
        peRatio
        pcfRatio
        pRevenueRatio
        pBVRatio
        evEBITDARatio
        evRevenueRatio
        currency
        isin
        countryCode
        gicsCode
        country {
          name
          alpha2Code
        }
        assetClass
      }
      nextToken
      total
    }
  }
`

export const listOwnerShareRatings = /* GraphQL */ `
  query listOwnerShareRatings(
    $filter: ModelShareRatingFilterInput
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    listOwnerShareRating(
      filter: $filter,
      sortDirection: $sortDirection,
      limit: $limit,
      nextToken: $nextToken
      inclInactive: true) {
      items {
        id
        name
        inactive
        ratedAt
        result
        pricePotential
        conditions {
          initial
          financialDataItemId
          customSharePositionValue
          basis
          weight
          result
          pricePotential
        }
        share {
          active
          covered
          delisted
          id
          name
          currency
          close
          isin
        }
        sector {
          id
          name
          level
        }
        owner
      }
      nextToken
    }
  }
`

export const findShareByIdForRating = /* GraphQL */ `
  query FindShareByIdForRating(
    $shareId: ID!
  )
  {
    getShare(id: $shareId) {
      id
      name
      isin
      company {
        sectorLevel1 {
          id
          name
        }
      }
    }
  }
`

export const getShareRating = /* GraphQL */ `
  query GetShareRating($id: ID!) {
    getShareRating(id: $id) {
      id
      name
      inactive
      shareRatingShareId
      ratedAt
      result
      pricePotential
      conditions {
        initial
        financialDataItemId
        customSharePositionValue
        basis
        weight
        result
        pricePotential
      }
      share {
        id
        active
        covered
        delisted
        ric
        name
        currency
        isin
        countryCode
        gicsCode
        marketCapital
        eps
        close
        closeDate
        latestPrice {
            price
            timestamp
            exchangeName
        }
        cashFlowPerShare
        ebitdaPerShare
        revenuePerShare
        bookValuePerShare
        company {
          id
          name
          mainShare
        }
        mainListing {
          timeSeries {
            id
            timestamp
            close
          }
        }
      }
      owner
      compareGroup {
        id
        name
        createdAt
        updatedAt
        members {
          nextToken
        }
        ratings {
          nextToken
        }
        owner
      }
      sector {
        id
        name
        level
        ratios {
          items {
            basis
            position
            value
          }
          nextToken
        }
      }
    }
  }
`

export const getMinimalShareRatingForAddToPortfolio = /* GraphQL */ `
  query GetShareRating($id: ID!) {
    getShareRating(id: $id) {
      share {
        id
        assetClass
        name
        latestPrice {
          price
          timestamp
          exchangeName
        }
        mainListing {
          id
        }
      }
    }
  }
`

export const getMinimalShareForAddToPortfolio = /* GraphQL */ `
  query GetShareById($instrumentId: ID!) {
    getShare(id: $instrumentId) {
      id
      assetClass
      name
      latestPrice {
        price
        timestamp
        exchangeName
      }
      mainListing {
        id
      }
    }
  }
`

export const getPositionGroupMembers = /* GraphQL */ `
  query GetPositionGroupMembers {
    getPositionGroup(id: "SHARE_RATING_DEFAULT") {
      id
      entries {
        items {
          id
          orderNumber
          subPosGroup {
            id
            name
            entries {
              items {
                id
                dataItem {
                  id
                  name
                  dividerItemId
                  dividerItemName
                  itemId
                }
              }
            }
          }
        }
      }
    }
  }
`

export const calculateShareRating = /* GraphQL */ `
  mutation CalculateShareRating($input: ShareRatingInput) {
    calculateShareRating(input: $input) {
      id
      name
      inactive
      ratedAt
      result
      pricePotential
      conditions {
        initial
        financialDataItemId
        customSharePositionValue
        basis
        weight
        result
        pricePotential
      }
      share {
        id
        active
        covered
        delisted
        ric
        name
        isin
        wkn
        close
        latestPrice {
            price
            timestamp
            exchangeName
        }
        eps
        cashFlowPerShare
        revenuePerShare
        bookValuePerShare
        ebitdaPerShare
        closeDate
        company { sectorLevel1 { name} }
        mainListing {
          timeSeries {
            id
            timestamp
            close
          }
        }
      }
      sector {
        id
        name
        level
        ratios {
          items {
            basis
            position
            value
          }
          nextToken
        }
      }
      owner
    }
  }`

export const deleteShareRating = /* GraphQL */ `
  mutation DeleteShareRating(
    $input: DeleteShareRatingInput!
    $condition: ModelShareRatingConditionInput
  ) {
    deleteShareRating(input: $input, condition: $condition) {
      id
    }
  }
`
